import React from 'react'

export const Link = (props) => {
  const {
    url = '',
    target = '_blank',
    download = '',
    ariaLabel = '',
    children,
  } = props

  const opensInNewTab = target === '_blank' && !download
  const linkProps = {
    href: url,
    rel: 'noopener noreferrer',
    target,
    className: 'site-link',
    ...(ariaLabel ? { 'aria-label': ariaLabel } : {}),
  }

  return download ? (
    <a {...linkProps} download={download}>
      {children}
    </a>
  ) : (
    <a {...linkProps}>
      {children}
      {opensInNewTab && !ariaLabel && (
        <span className="visually-hidden"> (opens in new tab)</span>
      )}
    </a>
  )
}

export default Link
